// store/store.js
import { configureStore } from "@reduxjs/toolkit";
import AuthReducer from "./redux/AuthSlice";

export const store = configureStore({
  reducer: {
    Auth: AuthReducer,
  },
  // Redux Toolkit automatically includes thunk by default
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
